import {
  UPDATE_SERVER_WHITELIST_IPS,
  SUBSCRIPTIONS_GET_SERVERS_META_DATA,
  SUBSCRIPTIONS_GET_SERVERS_STATUS,
  UPDATE_SERVER_GEOLOCATION_RESTRICTION,
  MANAGE_PRIVATE_CONNECTION,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import subscriptionsGetServersStatus from "@shared/services/tour/mockedApis/security/subscriptionsGetServersStatus.ts";
import subscriptionsGetServersMetaData from "@shared/services/tour/mockedApis/security/subscriptionsGetServersMetaData.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import updateServerWhitelistIps from "@shared/services/tour/mockedApis/security/updateServerWhitelistIps.ts";
import updateServerGeolocationRestrictions from "@shared/services/tour/mockedApis/security/updateServerGeolocationRestrictions.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";

export default {
  [SUBSCRIPTIONS_GET_SERVERS_STATUS]: (data?: object) =>
    subscriptionsGetServersStatus(data),
  [SUBSCRIPTIONS_GET_SERVERS_META_DATA]: (data?: object) =>
    subscriptionsGetServersMetaData(data),
  [UPDATE_SERVER_WHITELIST_IPS]: (data?: object) =>
    updateServerWhitelistIps(data),
  [UPDATE_SERVER_GEOLOCATION_RESTRICTION]: (data?: object) =>
    updateServerGeolocationRestrictions(data),
  [MANAGE_PRIVATE_CONNECTION]: () => genericEmptyResponse(),
} satisfies TourUrlMapping;
